/**
 * Copyright ©2022 Drivepoint
 */

import {useMemo} from "react";
import ServiceRegistry from "../services/ServiceRegistry";
import useRoutes from "./useRoutes";

export type PageProps = {
  current: any
};

export default function usePage(): PageProps {

  const routes = useRoutes();

  return useMemo<PageProps>(() => {
    return {
      current: ServiceRegistry.routeService.getPageByPathname(location.pathname)
    };
  }, [location.pathname, routes]);

}
